import React  from "react";
import "./App.css";
import Header from "./Components/Header";
import Typing from "./Components/Typing";

function App() {
   
  return (

     <div>
      <Header
       name="tannu"
       title1="ABout"
       title2="contact"
       />
    
    
      <Typing />
    </div>
  );

}

export default App;
